import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const LoginGate = props => {
  if (props.loggedIn) {
    return React.createElement(props.loggedInComponent, {});
  } else {
    return React.createElement(props.loggedOutComponent, {});
  }
};

const mapStateToProps = state => {
  return {
    loggedIn: state.token != null
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(LoginGate)
);



// WEBPACK FOOTER //
// ./frontend/src/components/login/LoginGate.js